var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "TcEventInscription" }, [
    _c(
      "div",
      { staticClass: "w-3/5 mx-auto py-5" },
      [
        _c("TcEventItem", {
          staticClass: "mb-5",
          attrs: { event: _vm.event, hide_buttons: "true" }
        }),
        _vm._v(" "),
        _c(
          "form",
          {
            staticClass: "form",
            attrs: { id: "EventInscriptionForm", action: "#" },
            on: { change: _vm.formChange, submit: _vm.submitForm }
          },
          [
            _c("div", { staticClass: "form-section" }, [
              _c(
                "h3",
                { staticClass: "flex items-center mb-3" },
                [
                  _c("TcIcon", {
                    staticClass: "h-6 w-6 mr-3",
                    attrs: { icon: "list-ul" }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "font-semibold" }, [
                    _vm._v("Entradas")
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "px-9 flex flex-col gap-3" }, [
                _c("div", [_vm._v("Tu entrada")]),
                _vm._v(" "),
                _c("hr"),
                _vm._v(" "),
                _c("div", [
                  _c("div", [
                    _c("div", { staticClass: "flex w-full gap-3" }, [
                      _c("div", { staticClass: "flex-1" }, [
                        _c("label", [_vm._v("Nombre")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.name,
                              expression: "name"
                            }
                          ],
                          attrs: {
                            required: "",
                            type: "text",
                            disabled: _vm.$root.user || _vm.$root.external_user
                          },
                          domProps: { value: _vm.name },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.name = $event.target.value
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "flex-1" }, [
                        _c("label", [_vm._v("Primer apellido")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.surname1,
                              expression: "surname1"
                            }
                          ],
                          attrs: {
                            required: "",
                            type: "text",
                            disabled: _vm.$root.user || _vm.$root.external_user
                          },
                          domProps: { value: _vm.surname1 },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.surname1 = $event.target.value
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "flex-1" }, [
                        _c("label", [_vm._v("Segundo apellido")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.surname2,
                              expression: "surname2"
                            }
                          ],
                          attrs: {
                            required: "",
                            type: "text",
                            disabled: _vm.$root.user || _vm.$root.external_user
                          },
                          domProps: { value: _vm.surname2 },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.surname2 = $event.target.value
                            }
                          }
                        })
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c("div", { staticClass: "flex w-full gap-3" }, [
                      _c("div", { staticClass: "flex-1" }, [
                        _c("label", [_vm._v("Correo electrónico")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.email,
                              expression: "email"
                            }
                          ],
                          attrs: {
                            required: "",
                            type: "email",
                            disabled: _vm.$root.user
                          },
                          domProps: { value: _vm.email },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.email = $event.target.value
                            }
                          }
                        })
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c("div", { staticClass: "flex w-full gap-3" }, [
                      _c("div", { staticClass: "flex-1" }, [
                        _c("label", [_vm._v("NIF")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.nif,
                              expression: "nif"
                            }
                          ],
                          attrs: {
                            required: "",
                            type: "text",
                            disabled:
                              _vm.$root.user_profile || _vm.$root.external_user
                          },
                          domProps: { value: _vm.nif },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.nif = $event.target.value
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "flex-auto" }, [
                        _c("label", [_vm._v("Dirección")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.address,
                              expression: "address"
                            }
                          ],
                          attrs: { required: "", type: "text" },
                          domProps: { value: _vm.address },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.address = $event.target.value
                            }
                          }
                        })
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c("div", { staticClass: "flex w-full gap-3" }, [
                      _c("div", { staticClass: "flex-1" }, [
                        _c("label", [_vm._v("Población")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.town,
                              expression: "town"
                            }
                          ],
                          attrs: { required: "", type: "text" },
                          domProps: { value: _vm.town },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.town = $event.target.value
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "flex-1" }, [
                        _c("label", [_vm._v("CP")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.postal_code,
                              expression: "postal_code"
                            }
                          ],
                          attrs: { required: "", type: "text" },
                          domProps: { value: _vm.postal_code },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.postal_code = $event.target.value
                            }
                          }
                        })
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _vm.event.check_bus
                  ? _c("div", [
                      _c(
                        "div",
                        { staticClass: "flex gap-1" },
                        [
                          _c("TcIcon", {
                            staticClass: "h-5 w-5 text-gray-500",
                            attrs: { icon: "bus" }
                          }),
                          _vm._v(" "),
                          _c("label", { staticClass: "flex" }, [
                            _vm._v("Quiero reservar guagua")
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "flex gap-3" }, [
                        _c("label", { staticClass: "block w-full" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.bus,
                                expression: "bus"
                              }
                            ],
                            staticClass: "hidden",
                            attrs: { type: "radio" },
                            domProps: {
                              value: true,
                              checked: _vm._q(_vm.bus, true)
                            },
                            on: {
                              change: function($event) {
                                _vm.bus = true
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "flex gap-3" }, [
                            _c("b", [_vm._v("Sí")]),
                            _vm.bus == true
                              ? _c("b", { staticClass: "ml-3 h-5 w-5" }, [
                                  _vm._v("✔")
                                ])
                              : _vm._e()
                          ])
                        ]),
                        _vm._v(" "),
                        _c("label", { staticClass: "block w-full" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.bus,
                                expression: "bus"
                              }
                            ],
                            staticClass: "hidden",
                            attrs: { type: "radio" },
                            domProps: {
                              value: false,
                              checked: _vm._q(_vm.bus, false)
                            },
                            on: {
                              change: function($event) {
                                _vm.bus = false
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "flex gap-3" }, [
                            _c("b", [_vm._v("No")]),
                            _vm.bus == false
                              ? _c("b", { staticClass: "ml-3 h-5 w-5" }, [
                                  _vm._v("✔")
                                ])
                              : _vm._e()
                          ])
                        ])
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.event.allow_companions
                  ? _c("div", [
                      _vm.companions.length == 0
                        ? _c("div", [
                            _c(
                              "button",
                              {
                                attrs: { type: "button" },
                                on: { click: _vm.addCompanion }
                              },
                              [
                                _vm._v("¿Quieres añadir acompañante? "),
                                _c("small", { staticClass: "ml-2" }, [
                                  _vm._v(
                                    "(hasta " +
                                      _vm._s(_vm.event.companions_limit) +
                                      ")"
                                  )
                                ])
                              ]
                            )
                          ])
                        : _c("div", [
                            _c("div", [
                              _vm._v("Tus acompañantes "),
                              _c("small", [
                                _vm._v(
                                  "(" +
                                    _vm._s(_vm.companions.length) +
                                    " de " +
                                    _vm._s(_vm.event.companions_limit) +
                                    ")"
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("hr", { staticClass: "my-3" }),
                            _vm._v(" "),
                            _c("table", [
                              _vm._m(0),
                              _vm._v(" "),
                              _c(
                                "tbody",
                                _vm._l(_vm.companions, function(companion, i) {
                                  return _c("tr", { key: companion.id }, [
                                    _c("td", [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: companion.name,
                                            expression: "companion.name"
                                          }
                                        ],
                                        attrs: { type: "text", required: "" },
                                        domProps: { value: companion.name },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              companion,
                                              "name",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      })
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: companion.nif,
                                            expression: "companion.nif"
                                          }
                                        ],
                                        attrs: { type: "text", required: "" },
                                        domProps: { value: companion.nif },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              companion,
                                              "nif",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      })
                                    ]),
                                    _vm._v(" "),
                                    _c("td", { staticClass: "price" }, [
                                      _vm._v(
                                        _vm._s(_vm.event.companions_amount)
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "action-remove",
                                          on: {
                                            click: function($event) {
                                              return _vm.removeCompanion(i)
                                            }
                                          }
                                        },
                                        [_vm._v("-")]
                                      )
                                    ])
                                  ])
                                }),
                                0
                              ),
                              _vm._v(" "),
                              _c("tfoot", [
                                _c("tr", [
                                  _c(
                                    "td",
                                    {
                                      staticClass: "pt-5",
                                      attrs: { colspan: "100%" }
                                    },
                                    [
                                      _vm.companions.length <
                                      _vm.event.companions_limit
                                        ? _c(
                                            "button",
                                            {
                                              staticClass: "bg-gray-500",
                                              attrs: { type: "button" },
                                              on: { click: _vm.addCompanion }
                                            },
                                            [_vm._v("Añadir otro acompañante")]
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                ])
                              ])
                            ])
                          ])
                    ])
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _vm.event.allow_guests
              ? _c("div", { staticClass: "form-section" }, [
                  _vm.guests.length == 0
                    ? _c("div", { staticClass: "px-9" }, [
                        _c(
                          "button",
                          {
                            attrs: { type: "button" },
                            on: { click: _vm.addGuest }
                          },
                          [
                            _vm._v("¿Quieres inscribir un invitado? "),
                            _c("small", { staticClass: "ml-2" }, [
                              _vm._v(
                                "(hasta " + _vm._s(_vm.event.guests_limit) + ")"
                              )
                            ])
                          ]
                        )
                      ])
                    : _c("div", [
                        _c(
                          "h3",
                          { staticClass: "flex items-center mb-3" },
                          [
                            _c("TcIcon", {
                              staticClass: "h-6 w-6 mr-3",
                              attrs: { icon: "list-ul" }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "font-semibold" }, [
                              _vm._v("Inscripción invitado")
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "px-9" }, [
                          _c("div", [
                            _vm._v("Datos del invitado "),
                            _c("small", [
                              _vm._v(
                                "(" +
                                  _vm._s(_vm.guests.length) +
                                  " de " +
                                  _vm._s(_vm.event.guests_limit) +
                                  ")"
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("hr", { staticClass: "my-3" }),
                          _vm._v(" "),
                          _c("table", [
                            _vm._m(1),
                            _vm._v(" "),
                            _c(
                              "tbody",
                              _vm._l(_vm.guests, function(guest, i) {
                                return _c("tr", { key: guest.id }, [
                                  _c("td", [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: guest.name,
                                          expression: "guest.name"
                                        }
                                      ],
                                      attrs: { required: "", type: "text" },
                                      domProps: { value: guest.name },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            guest,
                                            "name",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    })
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: guest.nif,
                                          expression: "guest.nif"
                                        }
                                      ],
                                      attrs: { required: "", type: "text" },
                                      domProps: { value: guest.nif },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            guest,
                                            "nif",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    })
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "price" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.event.guests_amount.strToEuro()
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "action-remove",
                                        on: {
                                          click: function($event) {
                                            return _vm.removeGuest(i)
                                          }
                                        }
                                      },
                                      [_vm._v("-")]
                                    )
                                  ])
                                ])
                              }),
                              0
                            ),
                            _vm._v(" "),
                            _c("tfoot", [
                              _c("tr", [
                                _c(
                                  "td",
                                  {
                                    staticClass: "pt-5",
                                    attrs: { colspan: "100%" }
                                  },
                                  [
                                    _vm.guests.length < _vm.event.guests_limit
                                      ? _c(
                                          "button",
                                          {
                                            staticClass: "bg-gray-500",
                                            attrs: { type: "button" },
                                            on: { click: _vm.addGuest }
                                          },
                                          [_vm._v("Añadir otro invitado")]
                                        )
                                      : _vm._e()
                                  ]
                                )
                              ])
                            ])
                          ])
                        ])
                      ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.event.allow_guests_children
              ? _c("div", { staticClass: "form-section" }, [
                  _vm.guests_children.length == 0
                    ? _c("div", { staticClass: "px-9" }, [
                        _c(
                          "button",
                          {
                            attrs: { type: "button" },
                            on: { click: _vm.addGuestChildren }
                          },
                          [
                            _vm._v("¿Quieres inscribir un niño invitado? "),
                            _c("small", { staticClass: "ml-2" }, [
                              _vm._v(
                                "(hasta " +
                                  _vm._s(_vm.event.guests_children_limit) +
                                  ")"
                              )
                            ])
                          ]
                        )
                      ])
                    : _c("div", [
                        _c(
                          "h3",
                          { staticClass: "flex items-center mb-3" },
                          [
                            _c("TcIcon", {
                              staticClass: "h-6 w-6 mr-3",
                              attrs: { icon: "list-ul" }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "font-semibold" }, [
                              _vm._v("Inscripción niño invitado")
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "px-9" }, [
                          _c("div", [
                            _vm._v("Datos del niño invitado "),
                            _c("small", [
                              _vm._v(
                                "(" +
                                  _vm._s(_vm.guests_children.length) +
                                  " de " +
                                  _vm._s(_vm.event.guests_children_limit) +
                                  ")"
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("hr", { staticClass: "my-3" }),
                          _vm._v(" "),
                          _c("table", [
                            _vm._m(2),
                            _vm._v(" "),
                            _c(
                              "tbody",
                              _vm._l(_vm.guests_children, function(
                                children,
                                i
                              ) {
                                return _c("tr", { key: children.id }, [
                                  _c("td", [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: children.name,
                                          expression: "children.name"
                                        }
                                      ],
                                      attrs: { required: "", type: "text" },
                                      domProps: { value: children.name },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            children,
                                            "name",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    })
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: children.nif,
                                          expression: "children.nif"
                                        }
                                      ],
                                      attrs: { type: "text" },
                                      domProps: { value: children.nif },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            children,
                                            "nif",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    })
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "price" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.event.guests_children_amount.strToEuro()
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "action-remove",
                                        on: {
                                          click: function($event) {
                                            return _vm.removeGuestChildren(i)
                                          }
                                        }
                                      },
                                      [_vm._v("-")]
                                    )
                                  ])
                                ])
                              }),
                              0
                            ),
                            _vm._v(" "),
                            _c("tfoot", [
                              _c("tr", [
                                _c(
                                  "td",
                                  {
                                    staticClass: "pt-5",
                                    attrs: { colspan: "100%" }
                                  },
                                  [
                                    _vm.guests_children.length <
                                    _vm.event.guests_children_limit
                                      ? _c(
                                          "button",
                                          {
                                            staticClass: "bg-gray-500",
                                            attrs: { type: "button" },
                                            on: { click: _vm.addGuestChildren }
                                          },
                                          [_vm._v("Añadir otro niño invitado")]
                                        )
                                      : _vm._e()
                                  ]
                                )
                              ])
                            ])
                          ])
                        ])
                      ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.eventQuestions.length
              ? _c("div", { staticClass: "form-section" }, [
                  _c(
                    "h3",
                    { staticClass: "flex items-center mb-3" },
                    [
                      _c("TcIcon", {
                        staticClass: "h-6 w-6 mr-3",
                        attrs: { icon: "list-ul" }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "font-semibold" }, [
                        _vm._v("Preguntas del evento")
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "px-9 flex flex-col gap-4" },
                    [
                      _vm._l(_vm.eventQuestions, function(question) {
                        return _c(
                          "div",
                          {
                            key: question.id,
                            staticClass: "flex flex-col gap-2"
                          },
                          [
                            _c("label", { staticClass: "font-bold" }, [
                              _vm._v(
                                "\n              " + _vm._s(question.name)
                              ),
                              question.required
                                ? _c("sup", { staticClass: "required-mark" }, [
                                    _vm._v("*")
                                  ])
                                : _vm._e()
                            ]),
                            _vm._v(" "),
                            question.type === "text"
                              ? _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.questionAnswers[question.id],
                                      expression: "questionAnswers[question.id]"
                                    }
                                  ],
                                  staticClass: "w-full",
                                  attrs: {
                                    type: "text",
                                    required: question.required
                                  },
                                  domProps: {
                                    value: _vm.questionAnswers[question.id]
                                  },
                                  on: {
                                    input: [
                                      function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.questionAnswers,
                                          question.id,
                                          $event.target.value
                                        )
                                      },
                                      _vm.updateFormState
                                    ]
                                  }
                                })
                              : question.type === "select"
                              ? _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.questionAnswers[question.id],
                                        expression:
                                          "questionAnswers[question.id]"
                                      }
                                    ],
                                    staticClass: "w-full",
                                    attrs: { required: question.required },
                                    on: {
                                      change: [
                                        function($event) {
                                          var $$selectedVal = Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function(o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function(o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                          _vm.$set(
                                            _vm.questionAnswers,
                                            question.id,
                                            $event.target.multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          )
                                        },
                                        _vm.updateFormState
                                      ]
                                    }
                                  },
                                  [
                                    _c("option", { attrs: { value: "" } }, [
                                      _vm._v("Seleccione...")
                                    ]),
                                    _vm._v(" "),
                                    _vm._l(question.options, function(option) {
                                      return _c(
                                        "option",
                                        {
                                          key: option,
                                          domProps: { value: option }
                                        },
                                        [_vm._v(_vm._s(option))]
                                      )
                                    })
                                  ],
                                  2
                                )
                              : question.type === "yesno"
                              ? _c("div", { staticClass: "flex gap-6" }, [
                                  _c(
                                    "label",
                                    {
                                      staticClass:
                                        "flex gap-2 items-center cursor-pointer"
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.questionAnswers[question.id],
                                            expression:
                                              "questionAnswers[question.id]"
                                          }
                                        ],
                                        attrs: {
                                          type: "radio",
                                          name: "question_" + question.id,
                                          value: "0"
                                        },
                                        domProps: {
                                          checked: _vm._q(
                                            _vm.questionAnswers[question.id],
                                            "0"
                                          )
                                        },
                                        on: {
                                          change: [
                                            function($event) {
                                              return _vm.$set(
                                                _vm.questionAnswers,
                                                question.id,
                                                "0"
                                              )
                                            },
                                            _vm.updateFormState
                                          ]
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("No")])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass:
                                        "flex gap-2 items-center cursor-pointer"
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.questionAnswers[question.id],
                                            expression:
                                              "questionAnswers[question.id]"
                                          }
                                        ],
                                        attrs: {
                                          type: "radio",
                                          name: "question_" + question.id,
                                          value: "1"
                                        },
                                        domProps: {
                                          checked: _vm._q(
                                            _vm.questionAnswers[question.id],
                                            "1"
                                          )
                                        },
                                        on: {
                                          change: [
                                            function($event) {
                                              return _vm.$set(
                                                _vm.questionAnswers,
                                                question.id,
                                                "1"
                                              )
                                            },
                                            _vm.updateFormState
                                          ]
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("Sí")])
                                    ]
                                  )
                                ])
                              : _vm._e()
                          ]
                        )
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "text-sm text-gray-600" }, [
                        _vm._v("Los campos marcados con * son obligatorios.")
                      ])
                    ],
                    2
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "form-section" }, [
              _c("div", { staticClass: "px-9 flex flex-col gap-3" }, [
                _c(
                  "div",
                  {
                    staticClass: "cursor-pointer flex",
                    on: {
                      click: function($event) {
                        _vm.showLegal = !_vm.showLegal
                      }
                    }
                  },
                  [
                    _vm.showLegal
                      ? _c("TcIcon", {
                          staticClass: "h-6 w-9 pt-1",
                          attrs: { icon: "chevron-up" }
                        })
                      : _c("TcIcon", {
                          staticClass: "h-6 w-9 pt-1",
                          attrs: { icon: "chevron-down" }
                        }),
                    _vm._v(" "),
                    _c("span", { staticClass: "font-semibold" }, [
                      _vm._v(
                        "\n              Mostrar las condiciones del evento\n            "
                      )
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.showLegal
                  ? _c("div", [
                      _c("span", { staticClass: "font-semibold" }, [
                        _vm._v(
                          "\n              CONSENTIMIENTO DEL ACOMPAÑANTE.\n            "
                        )
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.showLegal
                  ? _c("div", [
                      _vm._v(
                        "\n            El colegiado al inscribir en esta actividad a un acompañante mayor de edad se hará responsable de contar con el consentimiento expreso previo del titular del dato para el conjunto de tratamientos que conlleva dicha actividad. Se abstendrá de realizar cualquier tratamiento de datos si no cuenta con dicho consentimiento. En todo caso, el COIICO no será del responsable de dicho tratamiento siendo en exclusiva del colegiado en este acto.\n          "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.showLegal
                  ? _c("div", [
                      _c("span", { staticClass: "font-semibold" }, [
                        _vm._v("\n            MENORES DE EDAD.\n            ")
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.showLegal
                  ? _c("div", [
                      _vm._v(
                        "\n            El colegiado al inscribir en este evento a un acompañante menor de edad deberá:\n            "
                      ),
                      _vm._m(3),
                      _vm._v(
                        "\n\n            En ambos casos, deberán estar en disposición de acreditar dicha condición, bien mediante el libro de familia o mediante documento notarial o judicial que sostenga dicha acreditación. El COIICO denegará la participación en estos eventos si el solicitante no contara con la habilitación legal pertinente. En todo caso, el COIICO no será responsable de dicho tratamiento siendo en exclusiva del colegiado en este caso.\n          "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.showLegal
                  ? _c("div", [
                      _c("span", { staticClass: "font-semibold" }, [
                        _vm._v(
                          "\n            CONSENTIMIENTO PARA ACCIONES PUBLICITARIAS Y MARKETING\n            "
                        )
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.showLegal
                  ? _c("div", [
                      _vm._v(
                        "\n            La participación en este evento conlleva también su consentimiento expreso e inequívoco y el de las personas que le acompañan para poder realizar reportajes fotográficos, videos y emisión en directo de los eventos que este colegio celebre. También conlleva su consentimiento para poder dar divulgación a través de los canales de comunicación, redes sociales y página web del COIICO. Así como su publicación/divulgación a través de los canales de comunicación de los distintos patrocinadores cuando la actividad cuenten con patrocinador, para lo cual usted presta su consentimiento expreso e inequívoco.\n          "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.showLegal
                  ? _c("div", [
                      _c("span", { staticClass: "font-semibold" }, [
                        _vm._v("\n            ALERGIAS\n            ")
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.showLegal
                  ? _c("div", [
                      _vm._v(
                        "\n            La participación en algunas actividades puedo conllevar almuerzos, cenas o participación en comidas conjuntas. Si usted o alguno de las personas a las que usted inscriba tiene algún tipo de alergias alimentarias, deberá comunicar el número de personas que lo son y tipología de la alergia a fin de comunicar.\n          "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.showLegal
                  ? _c("div", [
                      _c("span", { staticClass: "font-semibold" }, [
                        _vm._v("\n            DESTINATARIOS\n            ")
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.showLegal
                  ? _c("div", [
                      _vm._v(
                        "\n            La participación es estos eventos puede conllevar la cesión y/o comunicación de sus datos personales así como de sus acompañantes a las entidades organizadoras o colaboradoras para el buen fin del mismo. Cada actividad indicará quién es el organizador del evento y, por tanto, quién será receptor de los datos en los casos que el acceso a los mismos estuviera motivado contractualmente.\n          "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm._m(4),
                _vm._v(" "),
                _vm.event.url_conditions
                  ? _c("div", { staticClass: "text-center" }, [
                      _c(
                        "a",
                        {
                          staticClass: "text-primary",
                          attrs: {
                            href: _vm.event.url_conditions,
                            target: "_blank"
                          }
                        },
                        [_vm._v("Condiciones específicas del servicio")]
                      )
                    ])
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _c("div", [
              _c(
                "button",
                {
                  staticClass: "flex gap-3",
                  attrs: { type: "button", disabled: _vm.is_form_disabled },
                  on: {
                    click: function($event) {
                      return _vm.setState("confirm")
                    }
                  }
                },
                [
                  _c("TcIcon", {
                    staticClass: "h-10 w-10",
                    attrs: { icon: "ok" }
                  }),
                  _vm._v(" "),
                  _c("div", [
                    _c("span", { staticClass: "py-4 text-3xl" }, [
                      _vm._v("Confirmar preinscripción")
                    ]),
                    _vm._v(" "),
                    _vm.is_form_disabled
                      ? _c("small", [_vm._v("(rellene todos los campos)")])
                      : _vm._e()
                  ])
                ],
                1
              )
            ])
          ]
        )
      ],
      1
    ),
    _vm._v(" "),
    _vm.state
      ? _c("div", { staticClass: "fixed z-10 inset-0 overflow-y-auto" }, [
          _c(
            "div",
            {
              staticClass:
                "flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
            },
            [
              _c("div", {
                staticClass:
                  "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity",
                attrs: { "aria-hidden": "true" }
              }),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass:
                    "hidden sm:inline-block sm:align-middle sm:h-screen",
                  attrs: { "aria-hidden": "true" }
                },
                [_vm._v("​")]
              ),
              _vm._v(" "),
              _vm.state == "confirm"
                ? _c("TcInscriptionConfirm", {
                    attrs: {
                      event: _vm.event,
                      guests: _vm.d_guests,
                      children: _vm.d_children,
                      companions: _vm.d_companions,
                      questions: _vm.confirmQuestions,
                      igic: _vm.$root.igic
                    }
                  })
                : _vm.state == "sending"
                ? _c("TcInscriptionSending")
                : _vm.state == "success"
                ? _c("TcInscriptionSuccess")
                : _vm.state == "error"
                ? _c("TcInscriptionError")
                : _vm._e()
            ],
            1
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Nombre")]),
        _c("th", [_vm._v("NIF")]),
        _c("th"),
        _c("th")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Nombre / Nº colegiado")]),
        _c("th", [_vm._v("NIF")]),
        _c("th"),
        _c("th")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Nombre")]),
        _c("th", [_vm._v("NIF")]),
        _c("th"),
        _c("th")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "pl-9 my-3 flex flex-col" }, [
      _vm._v(
        "\n              1. Contar con la patria potestad del menor.\n              "
      ),
      _c("br"),
      _vm._v(
        "\n              2. En caso de no contar con dicho título habilitante, deberá contar con el consentimiento expreso de los padres/tutores legales del menor.\n            "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "font-semibold flex items-center gap-3" }, [
      _c("input", {
        staticClass: "h-6 w-6",
        attrs: { required: "", type: "checkbox", id: "accept-conditions" }
      }),
      _vm._v(" "),
      _c("label", { attrs: { for: "accept-conditions" } }, [
        _vm._v("Acepto las condiciones del evento")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }